import * as React from 'react';
import { CurrentClientIdType } from '../current-client-route-state-context';

export type CurrentClientStorageStateContextType = CurrentClientIdType | undefined;

export const CurrentClientStorageStateContext = React.createContext<CurrentClientStorageStateContextType>(undefined);
CurrentClientStorageStateContext.displayName = 'CurrentClientStorageStateContext';
